module.exports = __webpack_public_path__ + "img/dcbc3d1.png";